export function isDevelopment() {
  return process.env.NEXT_PUBLIC_DEPLOY_ENV === 'development';
}
